module.exports = __webpack_public_path__ + "images/8033bc1f64b0c5d6d226693d88de547f-hotel.png";